import type { RouteObject } from 'react-router-dom';
import { AccountPage } from '../features/account/AccountPage';
import { AuditLogPage } from '../features/audit/AuditLogPage';
import { InvitationPage } from '../features/auth/InvitationPage';
import { SignInPage } from '../features/auth/SignInPage';
import { OperatorsPage } from '../features/operators/OperatorsPage';
import { OverviewPage } from '../features/overview/OverviewPage';
import { ProblemsPage } from '../features/problems/ProblemsPage';
import { ConsoleGate } from '../features/shell/ConsoleGate';
import { ConsoleShell } from '../features/shell/ConsoleShell';
import { NotFoundPage } from '../features/shell/NotFoundPage';
import { TenantPage } from '../features/tenants/TenantPage';
import { TenantsPage } from '../features/tenants/TenantsPage';

/** The console's routes (spec 140 §4.5). Public: sign-in and the invitation link; everything else behind the gate. */
export const routes: RouteObject[] = [
  { path: '/sign-in', element: <SignInPage /> },
  { path: '/invite/:token', element: <InvitationPage /> },
  {
    path: '/',
    element: <ConsoleGate>{(me) => <ConsoleShell me={me} />}</ConsoleGate>,
    children: [
      { index: true, element: <OverviewPage /> },
      { path: 'tenants', element: <TenantsPage /> },
      { path: 'tenants/:id', element: <TenantPage /> },
      { path: 'tenants/:id/:tab', element: <TenantPage /> },
      { path: 'problems', element: <ProblemsPage /> },
      { path: 'audit', element: <AuditLogPage /> },
      { path: 'operators', element: <OperatorsPage /> },
      { path: 'account', element: <AccountPage /> },
      { path: '*', element: <NotFoundPage /> },
    ],
  },
];
